import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/app/[mod]/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/app/app/[mod]/roles/[role]/diff/[hash]/LegacyFlowModal/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/app/[mod]/roles/[role]/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/app/components/ApplyUpdate/ApplyUpdateInteractive.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/components/Layout/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/app/[mod]/roles/[role]/diff/[hash]/page.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/components/DiffView/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/components/members/MembersList/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/app/components/permissions/ConditionView/PassConditionView.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/components/permissions/ConditionView/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/components/permissions/DiffBox/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/components/ContractName/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/components/permissions/PermissionsDiff/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/app/components/permissions/PresetItem/IndividualPermissionsExpandable.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/components/permissions/TargetItem/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/components/permissions/PresetItem/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/ui/Address/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/ui/Anchor/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/ui/BreadcrumbDivider/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/app/ui/Disclosure/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/ui/Flex/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/ui/LabeledData/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/ui/Box/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/ui/Alert/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/ui/Button/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/components/members/MembersDiff/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/app/ui/StopPropagation/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/ui/Switch/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/app/ui/TabGroup/index.tsx");
